/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Subscription_Trial_DescriptionInputs */

const nl_app_subscription_trial_description = /** @type {(inputs: App_Subscription_Trial_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jullie school maakt gebruik van een proefperiode.`)
};

/**

* @param {App_Subscription_Trial_DescriptionInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const app_subscription_trial_description = /** @type {((inputs?: App_Subscription_Trial_DescriptionInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Subscription_Trial_DescriptionInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_app_subscription_trial_description(inputs)
});
export { app_subscription_trial_description as "app.subscription.trial_description" }